import { render, staticRenderFns } from "./Indicacao.vue?vue&type=template&id=73927216&scoped=true&"
import script from "./Indicacao.vue?vue&type=script&lang=js&"
export * from "./Indicacao.vue?vue&type=script&lang=js&"
import style0 from "./Indicacao.vue?vue&type=style&index=0&id=73927216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73927216",
  null
  
)

export default component.exports